import React, { useEffect } from "react";
import Intercom from "@intercom/messenger-js-sdk";
import { useUserContext } from "../../contexts/userContext";  // Adjust the path as needed
import { useLocation } from "react-router-dom";
import { useIntercomService } from '../../services/intercomService';

const IntercomComponent = () => {
    const userContext = useUserContext();
    const location = useLocation();

    const { intercomUserHash, getIntercomUserHash } = useIntercomService();

    const userEntityId = userContext?.userInfo?.userEntityId

    useEffect(() => {
        if (!intercomUserHash || intercomUserHash === "") {
            getIntercomUserHash();
        }
    }, [intercomUserHash, getIntercomUserHash]); 

    useEffect(() => {
        if (intercomUserHash && intercomUserHash !== "") {
            Intercom({
                app_id: "aphvmvr2",
                user_id: userEntityId,
                user_hash: intercomUserHash, 
                name: `${userContext?.userInfo.firstName} ${userContext?.userInfo.lastName}`,
            });

            Intercom('update');
        }
    }, [location, userContext, intercomUserHash]);

    return null;
};

export default IntercomComponent;